import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';

import { guestAppUrl } from './guest-app-url';

export const GUEST_LINK_HELP_PATH = '/guest-link';

// Opens the guest app page a mistyped guest link meant; it is a separate app, so this
// takes a full page load. Links without a business show how to find the right page.
export const guestLinkGuard: CanActivateFn = (_route, state) => {
  const target = guestAppUrl(state.url);

  if (target !== null && !Capacitor.isNativePlatform()) {
    inject(DOCUMENT).location.replace(target);

    return false;
  }

  return inject(Router).parseUrl(GUEST_LINK_HELP_PATH);
};
